/**
 * Client ESM mirror of shared/severitySummaryCounts formatOpenSeverityCountLine.
 */

export function formatOpenSeverityCountLine(summary, extras = {}) {
  const s = summary && typeof summary === "object" ? summary : {};
  const parts = [
    `Critical: ${Number(s.criticalCount) || 0}`,
    `High: ${Number(s.highCount) || 0}`,
    `Medium: ${Number(s.mediumCount ?? s.warningCount) || 0}`,
    `Low: ${Number(s.lowCount ?? s.infoCount) || 0}`,
  ];
  if (extras.inconclusive != null) {
    parts.push(`Unable to evaluate: ${extras.inconclusive}`);
  }
  if (extras.healthy != null) {
    parts.push(`Healthy: ${extras.healthy}`);
  }
  return parts.join(" · ");
}
